export default {
    openAccountReg(testObj) {
        let finallyBool = false;
        switch (testObj.type) {
            case 'phone':
                if ((/^1\d{10}$/.test(testObj.testCont))) {
                    finallyBool = true
                }
                break;
            case 'card':
                // if((/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(testObj.testCont))){ 
                //     finallyBool = true
                // } 
                if ((/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(testObj.testCont))) {
                    finallyBool = true
                }
                break;
            case 'email':
                if ((/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(testObj.testCont))) {
                    // if ((/^\w.+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/.test(testObj.testCont))) {
                // if (testObj.testCont.indexOf('@') > -1) {
                    finallyBool = true
                }
                break;

        }
        return finallyBool
    }
}